import { createReducer } from '@reduxjs/toolkit'
import cloneDeep from 'lodash/cloneDeep'

import { DATES } from 'const/filters'
import { FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'

import { defaultDashboardPage } from '../defaults'

const defaultState = {
    [FILTERS]: {
        [DATES]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [],
        displayState: {},
    },

    ...defaultDashboardPage,
}

export default createReducer(cloneDeep(defaultState), () => {}) // create clone, so the defaultState is not mutated
